import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, ContentNode as ContentNodeT, HasChildren, Shapeable, Slice } from '@shapeable/types';
import { breakpoints, theme, ColorTokens } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ContentNode, SlicePersonBanner as SlicePersonBannerDefault, useLang, usePageEntity } from '@shapeable/ui';
import { Person } from '@shapeable/future-council-types';

const cls = classNames('slice-person-banner');

// -------- Types -------->

// -------- Props -------->

export type SlicePersonBannerProps = Classable & HasChildren & { 
  entity?: Slice;
};

export const SlicePersonBannerDefaultProps: Omit<SlicePersonBannerProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const MemberNumberStyles = breakpoints({
  base: css`
    
  `,
});



// -------- Components -------->

const My = {
  Container: styled(SlicePersonBannerDefault)<ContainerProps>`${ContainerStyles}`,
    MemberNumber: styled(ContentNode)`${MemberNumberStyles}`
};

export const SlicePersonBanner: Shapeable.FC<SlicePersonBannerProps> = (props) => {
  const { className, children, entity } = props;

  const t = useLang();

  const personEntity = usePageEntity() as Person;

  const { memberNumber, isAlumni, type } = personEntity || {};

  const memberNumberHtml: ContentNodeT = {
    text: t(`Member Number <strong>${memberNumber}</strong>`)
  };

  const isCouncilMember = !!type && type.slug === 'future-council-member';
  
  // let memberBadge = '';
  
  // if (isCouncilMember) {
  //   if (isAlumni === true) {
  //     memberBadge = t('Future Council Alumni');
  //   } else if (isAlumni === false) {
  //     memberBadge = t(type.name);
  //   } else if (isAlumni === null || isAlumni === undefined) {
  //     memberBadge = t(type.name); // empty badge means DOB is not filled out in platform.
  //   }
  // } else {
  //   memberBadge = t(type?.name || '');
  // }

  const memberBadge = isCouncilMember ? t(isAlumni ? 'Future Council Alumni' : type?.name || '') : t(type?.name || '');

  const hasMemberNumber = !!personEntity?.memberNumber;

  return (
    <My.Container 
      entity={entity}
      imageProps={{ alwaysShowIcon: true }}
      badge={memberBadge}
      className={cls.name(className)} 
      customFields={
        <>
          {hasMemberNumber && <My.MemberNumber entity={memberNumberHtml} />}
        </>
      }
      />
  )
};

SlicePersonBanner.cls = cls;